angular.module('BillPay')
    .controller('FooterCtrl', function ($scope, moment) {
        $scope.currentYear = moment().format('YYYY');
    });
